import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const t = ({
  title: l,
  titleId: o,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M926.699 250.261c-31.061 13.632-64.299 22.699-99.072 26.645 35.691-20.885 63.083-54.187 76.011-93.845-33.536 19.371-70.464 33.6-109.824 41.173-31.381-33.003-76.309-53.568-125.824-53.568-95.381 0-172.587 75.968-172.587 169.813 0 13.312 1.515 26.325 4.608 38.741-143.659-7.275-270.699-74.773-355.947-177.387-14.741 25.131-23.36 54.187-23.36 85.355 0 59.051 30.443 110.805 76.907 141.376-28.309-.917-54.763-8.491-78.144-21.184v2.112c0 82.325 59.371 150.741 138.432 166.485-14.443 3.947-29.824 6.037-45.525 6.037-11.072 0-21.845-1.195-32.619-3.008 21.867 67.499 85.845 116.544 161.216 118.059-59.072 45.397-133.525 72.64-214.443 72.64-13.824 0-27.669-.917-41.195-2.432 76.288 48.149 167.04 76.288 264.555 76.288 317.483 0 490.987-258.816 490.987-483.093 0-7.275-.32-14.848-.619-22.123a347.755 347.755 0 0 0 86.443-88.085z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = r(t);
export {
  m as default
};
